import { AnyAction } from 'redux';
import {
  FAVORITEBUTTON_SET_LOGIN_MODAL_OPEN,
  PENDING_ADD_TO_WISHLIST_PRODUCT,
  RESET_PENDING_ADD_TO_WISHLIST,
} from '../constants';
import Product from '../Types/Product';

export interface FavoriteButtonState {
  modalOpen: boolean;
  pendingAddToWishListProduct?: Product;
}

const DEFAULT_STATE: FavoriteButtonState = {
  modalOpen: false,
};

export const favoriteButton = (
  state = DEFAULT_STATE,
  action: AnyAction
): FavoriteButtonState => {
  switch (action.type) {
    case FAVORITEBUTTON_SET_LOGIN_MODAL_OPEN:
    case PENDING_ADD_TO_WISHLIST_PRODUCT:
    case RESET_PENDING_ADD_TO_WISHLIST:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
